module.exports = __webpack_public_path__ + "static/media/bposture.ccecbfd6.svg";